
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import DateField from './DateField';
import QuantityField from './QuantityField';
import { HarvestFormValues } from './schema';

interface BasicInfoSectionProps {
  form: UseFormReturn<HarvestFormValues>;
  isEditMode: boolean;
  showFarmIdField: boolean;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({ form, isEditMode, showFarmIdField }) => {
  return (
    <>
      {showFarmIdField && (
        <FormField
          control={form.control}
          name="farm_id"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Farm ID</FormLabel>
              <FormControl>
                <Input {...field} disabled={isEditMode} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      <FormField
        control={form.control}
        name="status"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Status</FormLabel>
            <Select 
              disabled={form.formState.isSubmitting} 
              onValueChange={field.onChange} 
              defaultValue={field.value}
              value={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select status" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="planned">Planned</SelectItem>
                <SelectItem value="in_progress">In Progress</SelectItem>
                <SelectItem value="completed">Completed</SelectItem>
                <SelectItem value="cancelled">Cancelled</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <DateField 
          form={form} 
          name="expected_date" 
          label="Expected Date" 
        />
        <QuantityField 
          form={form} 
          name="expected_quantity" 
          label="Expected Quantity (kg)" 
        />
      </div>
    </>
  );
};

export default BasicInfoSection;
